var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner-elem",class:{ 'has-delay': _vm.delay }},[_c('div'),_c('div'),_c('div')])}
var staticRenderFns = []

export { render, staticRenderFns }